import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSentimentNegativeSvg } from "./IconSentimentNegativeSvg.mjs";
import { IconSentimentPositiveSvg } from "./IconSentimentPositiveSvg.mjs";
import { IconSentimentSvg } from "./IconSentimentSvg.mjs";
const feelingToIcon = {
  positive: IconSentimentPositiveSvg,
  negative: IconSentimentNegativeSvg,
  neutral: IconSentimentSvg
};
const IconSentiment = ({
  feeling = "neutral",
  ...props
}) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: feelingToIcon[feeling] || feelingToIcon.neutral,
    ...svgProps
  }
) });
export {
  IconSentiment
};
